<script lang="ts" setup>
import { inject, ref } from "vue";
import { TranslationService } from "../../services/translation.service";
import { ToolsService } from "../../services/tools.service";
import { Clipper } from "../../helpers/clipper";
import { vInputText as vInputTextDir } from "../../directives/v-input-text";

const vInputText = vInputTextDir;

const t = (inject<TranslationService>("translationSvc") as TranslationService)
    .t;
const toolsSvc = inject<ToolsService>("toolsSvc") as ToolsService;

const model = ref({
    formula: "",
    // resStdAtWeight: 0,
    // resStdAtWeightText: '',
    resMolarMass: 0,
    resMolarMassText: "",
    hasError: false,
});

const onClickCalculate = (): void => {
    onChangeFormula();
};

const onChangeFormula = (): void => {
    // clear previous error
    if (model.value.hasError) {
        model.value.hasError = false;
    }

    let stdAtomicWeight: number | undefined;
    try {
        stdAtomicWeight = toolsSvc.molarMassFromMolecularFormula(
            model.value.formula,
        );
    } catch (ex) {
        console.warn(ex);
        model.value.hasError = true;
    }
    if (
        model.value.hasError ||
        typeof stdAtomicWeight !== "number" ||
        Number.isNaN(stdAtomicWeight)
    ) {
        // model.value.resStdAtWeight = 0;
        // model.value.resStdAtWeightText = '';
        model.value.resMolarMass = 0;
        model.value.resMolarMassText = "";
    } else {
        /** g/mol */
        const molarMass = stdAtomicWeight * toolsSvc.Mu;

        // model.value.resStdAtWeight = stdAtomicWeight;
        // model.value.resStdAtWeightText = stdAtomicWeight.toString() + ' u';
        model.value.resMolarMass = molarMass;
        model.value.resMolarMassText = molarMass.toString() + " g/mol";
    }
};

// public onCopyAtomicWeight(): void {
//   navigator.clipboard.writeText( model.value.resStdAtWeight.toString() );
// }

const onCopyMolarMass = (): void => {
    Clipper.write(model.value.resMolarMass).catch(() => {
        alert("Unable to copy value");
    });
};
</script>

<template>
    <div class="tool-content-inner pt-4">
        <label class="text-f7">{{ t("Molecular Formula") }}</label>
        <div class="w-full relative mt-2 mb-4">
            <input
                class="px-5 py-3 w-full bg-grey-50 rounded-s"
                :class="{ 'border-red border': model.hasError }"
                type="text"
                v-model="model.formula"
                @keyup="onChangeFormula()"
                placeholder="C6H12O6"
            />
            <i
                class="far fa-calculator text-primary absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
                @click="onClickCalculate()"
            ></i>
        </div>

        <label class="text-f7">{{ t("Calculated Molar Mass") }}</label>
        <div class="w-full relative mt-2">
            <input
                class="px-5 py-3 w-full bg-grey-50 rounded-s"
                type="text"
                v-model="model.resMolarMassText"
                placeholder="Calculated Molar Mass"
                readonly
            />
            <i
                class="far fa-copy text-primary absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
                @click="onCopyMolarMass()"
            ></i>
        </div>
    </div>
</template>
